import { useCallback } from "react";
import { ApolloError } from "@apollo/client";
import {
  useUpdateCart,
  UpdateCartData,
  UpdateCartProps,
} from "src/hooks/useUpdateCart";
import { ExecutionResult } from "graphql";
import { CartInfo } from "src/types/cartInfo";

interface AddDiscountCodeToCartHook {
  data?: UpdateCartData;
  loading: boolean;
  error?: ApolloError;
  updateCartShippingMethod: (
    id: string,
    cartInfo: CartInfo
  ) => Promise<ExecutionResult<UpdateCartData> | undefined>;
}

function useUpdateCartShippingMethod({
  refetchQueries = [],
  onCompleted,
  onError,
}: UpdateCartProps = {}): AddDiscountCodeToCartHook {
  const { updateCart, loading, error } = useUpdateCart({
    refetchQueries,
    onCompleted,
    onError,
  });

  const updateCartShippingMethod: AddDiscountCodeToCartHook["updateCartShippingMethod"] =
    useCallback(
      async (id, cartInfo) => {
        return await updateCart({
          cartInfo,
          actions: [
            {
              setShippingMethod: {
                shippingMethod: {
                  id,
                },
              },
            },
          ],
        });
      },
      [updateCart]
    );

  return { updateCartShippingMethod, loading, error };
}

export { useUpdateCartShippingMethod };
